<template>
  <div class="container-fluid bg-card-linear">
    <div class="row moreAbout">
      <div class="col">
        <div class="row">
          <div class="col">
            <div>{{$t('maintenance_Followup')}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="font-30">
              {{$t('valuedPartner')}}
            </div>
          </div>
          <div class="col-12 col-md-3 text-start content-center" v-if="val.expireDate">
            <span>{{$t('renewal')}}</span>
            <span class="mx-2">{{moment(val.expireDate).format('LL')}}</span>
          </div>
          <div class="col-auto active_system content-center">
            <span class="circle"></span>
            <span class="mx-2">{{$t('maintenanceSystem')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col pt-4">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('citiesList.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3"><router-link  to="/packagesList">{{$t('subscriptionPackages')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3" aria-current="page">{{val.title}}</li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="text-center">
      <errorAlert v-if="hasError" :alertMessage="message" :errorNumber='errorNumber' />
    </div>
    <div v-if="isLoading" class="row justify-content-center">
      <div class="col-12 col-md-8 text-center">
        <mainloader />
      </div>
    </div>

    <div v-else class="row pt-3">
      <div class="col-12">
        <!--begin:packages list !subscription -->
        <div class="row">
          <div class="col-12 col-md-6 subscription" v-for="(row,index) in rows" :key="index">
            <div class="card">
              <div class="card-body">
                <img :src="MEDIA_URL+row.image" class="img-fluid" alt="">
                <div class="row title">
                  <div class="col">
                    {{row.title}}
                  </div>
                  <div class="col-auto">
                    <span>{{row.price}}</span>
                    <span class="mx-1">{{$t('currency')}}</span>
                  </div>
                </div>
                <div class="row pt-2">
                  <div class="col description">
                    {{row.description}}
                  </div>
                </div>
              <div>
            </div>
            <!-- <div class="card target">
              <div class="card-body">
                <div class="almarai-bold">{{$t('target')}}</div>
                <div class="row p-2">
                  <div class="col-auto">
                    <img src="/assets/images/icons/user.png" class="max-16" alt="">
                    <span class="mx-1">{{$t('homeowners')}}</span>
                  </div>
                  <div class="col-auto mx-2">
                    <img src="/assets/images/icons/home.png" class="max-16" alt="">
                    <span class="mx-1">{{$t('apartmentOwners')}}</span>
                  </div>
                </div>
              </div>
            </div> -->

                <!-- <div class="row pt-3">
                  <div class="col">
                    <div class="card featuresIncluded">
                      <div class="card-body">
                        <div class="almarai-bold">{{$t('featuresIncluded')}}</div>
                        <div class="row features">
                          <div class="col-12" v-for="(val, indx) in row.features" :key="indx">
                            <span>
                              <img src="/assets/images/icons/tick-circle.png" class="w-24"  alt="">
                            </span>
                            <span class="mx-2">{{val}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <!-- <div class="row pt-3">
                  <div class="col">
                    <div class="card featuresIncluded">
                      <div class="card-body">
                        <div class="almarai-bold">{{$t('termsConditions')}}</div>
                        <div class="row features">
                          <div class="col-12">
                            {{row.terms}} .
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="row pt-3 justify-content-center">
                  <div class="col-12 col-md-6 btn-green text-center">
                    <router-link :to="'/detailsMaintenance?packageID='+row.id" class="text-white">
                      <div class="btnpackageDetails">{{$t('packageDetails')}}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end:packages list !subscription -->

        <!--begin:packages list subscription -->
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-md-4" v-if="val.visitsCount">
                <div class="card listSubscription">
                  <div class="card-body">
                    <div>{{val.visitsCount}}</div>
                    <p>{{$t('visitsCount')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4" v-if="val.usedVisits">
                <div class="card listSubscription">
                  <div class="card-body">
                    <div class="usedVisits">{{val.usedVisits}}</div>
                    <p>{{$t('usedVisits')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4  discountValue" v-if="val.discountPercentage">
                <div class="card listSubscription">
                  <div class="card-body">
                    <div class="discountPercentage">{{val.discountPercentage}} %</div>
                    <p>{{$t('discountPercentage')}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-3" v-if="!isLoading && userPackageUsages && userPackageUsages.length">
              <div class="col ordersReceived">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col resceived">
                        {{$t('ordersReceived')}}
                      </div>
                      <div class="col-auto orderStatus">
                        {{statusChoices[val.status]}}
                      </div>
                      <div class="row pt-3">
                        <div class="col">
                          <table class="table text-center">
                            <thead class="maintenanceDetails">
                              <tr>
                                <th scope="col">{{$t('maintenanceDetailslocation')}}</th>
                                <th scope="col">{{$t('orderNumber')}}</th>
                                <th scope="col">{{$t('orderStatus')}}</th>
                                <th scope="col">{{$t('orderDate')}}</th>
                                <th scope="col">{{$t('procedure')}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item,indx) in userPackageUsages" :key="indx" class="verticalMiddle">
                                <td class="maintenanceOrdertitle">{{item.MaintenanceOrder.title}}</td>
                                <td class="maintenanceOrderid">{{item.MaintenanceOrder.id}} #</td>
                                <td class="status-td">
                                  <div :class="(item.MaintenanceOrder.status == 'new') ? 'orderStatuschoices statusNew' : (item.MaintenanceOrder.status == 'done') ? 'orderStatuschoices statusCompleted' : 'orderStatuschoices statusInProgress'">
                                    {{orderStatusChoices[item.MaintenanceOrder.status]}}
                                  </div>
                                </td>
                                <td>{{moment(item.createdAt).calendar()}}</td>
                                <td>
                                  <div class="usageType">{{item.usageType}}</div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row pt-3 justify-content-center">
              <div class="col-11 col-md-5 viewAllRequests">
                <router-link to="/maintenanceslist">
                  <div>{{$t('viewAllRequests')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!--end:packages list subscription -->

      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name:"PackagesView",
  data(){
    return{
      subscriptionId: this.$route.params.id,
      isLoading: true,
      hasError: false,
      message: '',
      errorNumber: null,
      rows:[],
      val: {},
      statusChoices: {},
      userPackageUsages: [],
      userLang: 'ar',
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER'])
  },
  methods: {
    getmPackages(){
      this.$http.get('/api/mPackages/subscription/'+this.subscriptionId).then(res => {
        this.val = res.data.row;
        this.userPackageUsages = res.data.row.UserPackageUsages;
        this.orderStatusChoices = res.data.orderStatusChoices;
        this.statusChoices = res.data.statusChoices;
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      })
    },
    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },
  },
  created(){
    this.getmPackages();
    window.scrollTo({top:0, behavior: 'smooth'});
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>